import Modal from "@/common/elements/Modal";
import BookingHoldsForm from "./BookingHoldsForm";
import { forwardRef, useEffect, useState } from "react";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { hasCheckSecurity } from "@/util/common_function";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";

const BookingHoldsModal = forwardRef(({
  show,
  onHide,
  selectedHold,
  updateStoreObj,
  holdFormRef,
  isEdit,
  setIsEdit
}) => {
const [isDisabled,setIsDisabled]=useState(false);
  const onModalHide = () => {
    onHide();
  };

  const onSaveClick = () => {
    updateStoreObj()
  };
    useEffect(() => {
        if (isEdit) {
            let isShow = hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.MODIFY,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
            )
            if (isShow) {
                setIsDisabled(false)
            }
            else {
                setIsDisabled(true)
            }
        } else {
            setIsDisabled(false)
        }
    }, [isEdit])

  return (
    <>
      <Modal
      header="Holds"
        show={show}
        onHide={onModalHide}
        size="xl"
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: onSaveClick,
            disabled:isDisabled
          },
        ]}
        footerCloseAction={()=>setIsDisabled(false)}
        footerCloseActionText="Close">
        
        <BookingHoldsForm holdFormRef={holdFormRef} selectedHold={selectedHold} />
     
      </Modal>
    </>
  );
});

export default BookingHoldsModal;